import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import './OfferBanner.css';

const OfferBanner = ({ images }) => {
  if (!images || images.length === 0) {
    return <div className="container">No offers available</div>;
  }

  return (
    <div className="container offer-image my-2">
      <div className="row ">
        {images.map((image, index) => (
          <div key={image._id || index} className="col-md-6 my-2 ">
            <Link to={`/product/${image.productId}`}>
              <img
                src={image.url}
                alt={`Offer ${index + 1}`}
                className="img-fluid banner-img "
              />
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

OfferBanner.propTypes = {
  images: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string,
      productId: PropTypes.string,
      url: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default OfferBanner;   